module.exports = __webpack_public_path__ + "img/product_02.8dd43109.jpg";